import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { markBasicCheckoutReturn } from '../utils/checkoutReturn';
import { Star, ShieldCheck, ChevronDown, ChevronUp, Clock, Lock, CreditCard } from 'lucide-react';
export const Testimonials2 = () => {
  const testimonials = [{
    initials: 'LM',
    name: 'Luciana M.',
    location: 'Mendoza | El Arsenal del Profe',
    text: 'Tengo 12 grupos distintos por semana. Antes llegaba agotada al lunes. Ahora abro el tomo que necesito y listo. No hay vuelta atrás.'
  }, {
    initials: 'JP',
    name: 'Juan P.',
    location: 'La Plata | Arsenal + Potenciador',
    text: 'El Tomo 1 me salvó el día que llegué y el depósito estaba con llave. Hice una clase entera sin un solo material y los chicos no se dieron cuenta.'
  }, {
    initials: 'VR',
    name: 'Valeria R.',
    location: 'Santa Fe | Escuela Secundaria',
    text: 'El Potenciador me cambió la forma de usar las pelotas y los conos. Mis alumnos de 4to año me preguntan si vamos a hacer el circuito de nuevo.'
  }, {
    initials: 'FA',
    name: 'Federico A.',
    location: 'Neuquén | Instructor Deportivo',
    text: 'No soy profe de escuela pero guío grupos de actividad física. Funciona igual de bien para mí. El Bono de Frases GAP es oro puro.'
  }];
  return <Section className="bg-[#060f1c]" data-id="element-202" data-mp="3kbugspgc1wfh">
      <FadeIn className="text-center mb-4 md:mb-10" data-id="element-203" data-mp="3gbk8h652itxg">
        <h2 className="text-xl md:text-4xl font-bold text-white mb-1.5 md:mb-3" data-id="element-204" data-mp="3gascvvbh0w76">
          Lo que dicen los profes, que ya utilzan el MEGAPACK.
        </h2>
        <div className="flex items-center justify-center gap-1.5 md:gap-2 text-gray-300 text-[11px] md:text-base" data-id="element-205" data-mp="3pci2qwppfn2u">
          <div className="flex text-yellow-400" data-id="element-206" data-mp="1zwimywrkyze8">
            {[...Array(5)].map((_, j) => <Star key={j} className="fill-current w-[11px] h-[11px] md:w-[14px] md:h-[14px]" data-id="element-207" data-mp="1uyqtvzf7978g" data-mpi={j} />)}
          </div>
          <span className="font-semibold" data-id="element-208" data-mp="3v2tc36sec21i">4.9/5</span>
          <span className="text-gray-500" data-id="element-209" data-mp="3uyt7fm30i6a">·</span>
          <span data-id="element-210" data-mp="7vr3mc6owt45">+500 profes del país</span>
        </div>
      </FadeIn>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2.5 md:gap-6" data-id="element-211" data-mp="7ufz2a5f7hbz">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-212" data-mp="htyfigm4gkza" data-mpi={i}>
            <div className="bg-[#0c1626] p-3 md:p-6 rounded-xl md:rounded-2xl shadow-sm border border-white/10 h-full flex flex-col hover:shadow-md transition-shadow" data-id="element-213" data-mp="htf7psq6rcyz">
              <div className="flex items-center gap-2.5 md:gap-3 mb-2 md:mb-4" data-id="element-214" data-mp="rji0brteaows">
                <div className="w-8 h-8 md:w-10 md:h-10 bg-brandOrange text-white rounded-full flex items-center justify-center font-bold text-[11px] md:text-sm shrink-0" data-id="element-215" data-mp="vl3hvqgvjrdb">
                  {t.initials}
                </div>
                <div className="min-w-0 flex-1" data-id="element-216" data-mp="15kkms5oay188">
                  <div className="flex text-yellow-400 mb-0.5 md:mb-1" data-id="element-217" data-mp="15h6iuszzpjyo">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-218" data-mp="1antwf4faer7h" data-mpi={j} />)}
                  </div>
                  <p className="font-bold text-white text-[12px] md:text-sm leading-tight truncate" data-id="element-219" data-mp="15qbkd55z3vv9">
                    {t.name}
                  </p>
                  <p className="text-[10px] md:text-xs text-gray-400 truncate" data-id="element-220" data-mp="11q1fxwxtxdii">
                    📍 {t.location}
                  </p>
                </div>
              </div>
              <p className="text-gray-300 text-[12px] md:text-sm italic leading-snug" data-id="element-221" data-mp="1tfmn2s6vw0c1">
                "{t.text}"
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Guarantee = () => {
  return <Section className="bg-[#070f1e] text-white" data-id="element-222" data-mp="2h4yxfvdy6efx">
      <FadeIn className="max-w-xl mx-auto" data-id="element-223" data-mp="2h5qiic9x4try">
        <div className="bg-[#0c1626] border border-brandOrange/30 rounded-2xl p-5 md:p-7 text-center shadow-lg shadow-brandOrange/5" data-id="element-224" data-mp="2cd70n3477chc">
          <ShieldCheck size={44} className="mx-auto text-brandOrange mb-3 md:mb-4" data-id="element-225" data-mp="1wu4e72d7gq2o" />
          <h2 className="text-lg md:text-2xl font-bold mb-3 md:mb-4 leading-tight" data-id="element-226" data-mp="21spfl5471fsp">
            🛡️ GARANTÍA 30 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="text-sm md:text-base text-gray-300 space-y-1.5 md:space-y-2 mb-3 md:mb-4 leading-snug" data-id="element-227" data-mp="1rw2ymrezn8vy">
            <p data-id="element-228" data-mp="2fn8cx25a5t45">Abrís los tomos. Los usás en clase.</p>
            <p className="text-white font-bold text-base md:text-lg py-1" data-id="element-229" data-mp="2kla5qesid6st">
              Si en 30 días no es lo que esperabas:
              <br data-id="element-230" data-mp="26ueq8jni7rg9" />
              devolución del 100%.
            </p>
            <p data-id="element-231" data-mp="2avgujewa2tp3">Sin formularios. Sin drama. Sin vueltas.</p>
            <p className="text-xs md:text-sm" data-id="element-232" data-mp="2atxdhm2ssem9">
              Un mail a{' '}
              <a href="mailto:soportecentershop95@gmail.com" className="text-brandOrange hover:underline break-all" data-id="element-233" data-mp="2ykt44fvip3rx">
                soportecentershop95@gmail.com
              </a>{' '}
              y listo.
            </p>
          </div>
          <p className="text-[11px] md:text-xs text-gray-500 font-medium" data-id="element-234" data-mp="my93ekspgxe5">
            Tasa de devoluciones: menos del 2%.
          </p>
        </div>
      </FadeIn>
    </Section>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve para primaria y secundaria?',
    a: 'Sí. Los 6 Tomos están pensados para ambos niveles. Cada actividad indica para qué edad y contexto funciona mejor.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital. PDF de alta calidad. Acceso inmediato al pago. En menos de 5 minutos tenés todo en tu celular o computadora.'
  }, {
    q: '¿Funciona si no soy profe de escuela?',
    a: 'Sí. Cualquier persona que guíe grupos de actividad física (instructores, animadores, recreadores, profesores particulares) puede usar este sistema sin problema.'
  }, {
    q: '¿Necesito materiales deportivos para usarlo?',
    a: 'No. Los 6 Tomos del Arsenal están diseñados para funcionar sin ningún material. El Potenciador (upsell opcional) usa materiales que ya están en cualquier escuela o gimnasio.'
  }, {
    q: '¿Tiene garantía real?',
    a: '30 días. Sin preguntas. Sin formularios. Un mail y te devolvemos el 100%.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-[#060f1c]" data-id="element-235" data-mp="1dpet2af802n6">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-236" data-mp="1dqg5ai7z2v6h">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-10" data-id="element-237" data-mp="1inq3ondcah6g">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>
        <div className="space-y-4" data-id="element-238" data-mp="1nmavpziftujt">
          {faqs.map((faq, i) => <div key={i} className="bg-[#0c1626] border border-white/10 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-239" data-mp="1seb3uf8nvtrh" data-mpi={i}>
              <button className="w-full px-6 py-4 text-left font-bold text-white flex justify-between items-center hover:bg-white/5 transition-colors" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-240" data-mp="zx8hz2qxclul">
                <span data-id="element-241" data-mp="396y10ymffl4s">{faq.q}</span>
                {openIndex === i ? <ChevronUp className="text-brandOrange" data-id="element-242" data-mp="3460i2jtlen28" /> : <ChevronDown className="text-gray-400" data-id="element-243" data-mp="2z8s28pvx2v45" />}
              </button>
              {openIndex === i && <div className="px-6 pb-4 text-gray-300" data-id="element-244" data-mp="2uaguckp6muok">{faq.a}</div>}
            </div>)}
        </div>
      </FadeIn>
    </Section>;
};
export const CostOfNotHaving = () => {
  const costs = [{
    sin: '3 horas de búsqueda de juegos por semana',
    costo: '120 horas de tu vida por año'
  }, {
    sin: 'Clases sin estructura',
    costo: 'Grupos que se te van de las manos'
  }, {
    sin: 'Sin plan B para lluvia',
    costo: 'Clase perdida + estrés innecesario'
  }, {
    sin: 'Sin consignas listas',
    costo: 'Explicás 3 veces y la mitad no entiende'
  }, {
    sin: 'Siempre los mismos juegos',
    costo: 'Grupos que se aburren y no participan'
  }, {
    sin: 'Domingo buscando en Google',
    costo: 'El mismo ciclo, el próximo año'
  }];
  return <Section className="bg-[#070f1e] text-white" data-id="element-245" data-mp="3qdw97dihi9fc">
      <FadeIn className="max-w-4xl mx-auto" data-id="element-246" data-mp="3qckzkx2cy7gb">
        <h2 className="text-xl md:text-4xl font-bold text-center mb-4 md:mb-12 text-brandOrange leading-tight" data-id="element-247" data-mp="3boztcua6rs46">
          ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
        </h2>

        <div className="bg-white/5 rounded-xl md:rounded-3xl overflow-hidden border border-white/10 mb-5 md:mb-10" data-id="element-248" data-mp="3gi2rlfpwrpqp">
          <div className="grid grid-cols-2 bg-white/10 px-2.5 py-2 md:p-4 font-bold text-[11px] md:text-base" data-id="element-249" data-mp="37nodvhl10n9p">
            <div className="text-gray-300" data-id="element-250" data-mp="2sq5g5pqdezq4">Sin El Arsenal</div>
            <div className="text-white pl-2.5 md:pl-4 border-l border-white/10" data-id="element-251" data-mp="2ssqgubexn9ma">
              Costo real
            </div>
          </div>
          <div className="divide-y divide-white/5" data-id="element-252" data-mp="2e3f69zykzysx">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 px-2.5 py-2.5 md:p-6 gap-2.5 md:gap-4 text-[11px] md:text-base items-center hover:bg-white/5 transition-colors leading-snug" data-id="element-253" data-mp="2a2v76qug6l45" data-mpi={i}>
                <div className="text-gray-400 pr-1.5 md:pr-4" data-id="element-254" data-mp="2j29vpkr20lm0">{row.sin}</div>
                <div className="text-red-400 font-medium pl-2.5 md:pl-4 border-l border-white/10 flex items-center gap-1.5 md:gap-2" data-id="element-255" data-mp="2x2azb7ype756">
                  <span className="hidden md:inline" data-id="element-256" data-mp="2t0pn7otztww1">→</span> {row.costo}
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center space-y-1.5 md:space-y-4" data-id="element-257" data-mp="31t11ydfqvvw6">
          <p className="text-lg md:text-3xl font-bold text-white leading-tight" data-id="element-258" data-mp="31vm4l4nvafuz">
            El próximo domingo puede ser diferente.
          </p>
          <p className="text-xs md:text-lg text-gray-300 max-w-2xl mx-auto leading-snug" data-id="element-259" data-mp="3bsi6grj9g3qk">
            Podés improvisar la próxima clase, o entrar con todo resuelto.
          </p>
          <p className="text-base md:text-2xl font-bold text-brandOrange" data-id="element-260" data-mp="397adqiqsc8w8">
            Vos decidís.
          </p>
        </div>
      </FadeIn>
    </Section>;
};
export const FinalCTA = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const [selected, setSelected] = useState<'plus' | 'basic'>('plus');
  const offers = {
    plus: {
      checkoutUrl: 'https://www.centershop.store/cart/47776144556183:1',
      cta: 'QUIERO EL ARSENAL + POTENCIADOR',
      value: 27990,
      contentName: 'MegaPack Arsenal + Potenciador',
      contentId: 'arsenal-potenciador'
    },
    basic: {
      checkoutUrl: 'https://www.centershop.store/cart/47775955288215:1',
      cta: 'QUIERO MI ARSENAL AHORA',
      value: 16990,
      contentName: 'MegaPack El Arsenal del Profe',
      contentId: 'arsenal-basico'
    }
  } as const;
  const current = offers[selected];
  return <Section className="bg-[#060f1c] border-t border-white/10 pt-16 pb-24" data-id="element-261" data-mp="27k194psqq0gu">
      <FadeIn className="max-w-3xl mx-auto text-center" data-id="element-262" data-mp="n1gyf56jxv7c">
        <div className="inline-flex items-center gap-2 bg-red-500/15 border border-red-500/40 text-red-300 font-bold px-4 py-1.5 rounded-full mb-6 md:mb-8 text-xs md:text-sm uppercase tracking-wide" data-id="element-263" data-mp="rxxpa754yno4">
          🚨 Última oportunidad
        </div>
        <div className="mb-8 md:mb-12" data-id="element-264" data-mp="10t5ax9kpqlou">
          <div className="inline-flex items-center gap-2 bg-brandOrange/10 border border-brandOrange/30 px-3 py-1 rounded-full mb-3 md:mb-4" data-id="element-265" data-mp="15qna488xhmjn">
            <span className="w-1.5 h-1.5 rounded-full bg-brandOrange animate-pulse" data-id="element-266" data-mp="1annhcmhikvcc"></span>
            <span className="text-[10px] md:text-xs font-bold text-brandOrange uppercase tracking-[0.2em]" data-id="element-267" data-mp="1fpmidpps7g64">
              El precio cierra en
            </span>
          </div>
          <div className="inline-flex items-center gap-1.5 md:gap-3 bg-[#070f1e] border-2 border-brandOrange rounded-2xl md:rounded-3xl px-3 py-3 md:px-6 md:py-5 animate-counter-glow" data-id="element-268" data-mp="3hgg8h6xebfsd">
            <div className="flex flex-col items-center min-w-[58px] md:min-w-[78px]" data-id="element-269" data-mp="sm9l76lnt95s">
              <div className="text-3xl md:text-5xl font-black text-brandOrange leading-none tabular-nums" data-id="element-270" data-mp="nnyc4y36v2om">
                {hours.toString().padStart(2, '0')}
              </div>
              <div className="text-[9px] md:text-[10px] text-gray-400 mt-1.5 md:mt-2 uppercase font-bold tracking-[0.2em]" data-id="element-271" data-mp="11l4syn4cqrb7">
                hs
              </div>
            </div>
            <div className="text-2xl md:text-4xl font-black text-brandOrange/60 leading-none -mt-3 md:-mt-4" data-id="element-272" data-mp="1bjszaomz5hz2">
              :
            </div>
            <div className="flex flex-col items-center min-w-[58px] md:min-w-[78px]" data-id="element-273" data-mp="1lb749bxp39zl">
              <div className="text-3xl md:text-5xl font-black text-brandOrange leading-none tabular-nums" data-id="element-274" data-mp="1gcdofcuxr6w9">
                {minutes.toString().padStart(2, '0')}
              </div>
              <div className="text-[9px] md:text-[10px] text-gray-400 mt-1.5 md:mt-2 uppercase font-bold tracking-[0.2em]" data-id="element-275" data-mp="1ua2csuo7ow62">
                min
              </div>
            </div>
            <div className="text-2xl md:text-4xl font-black text-brandOrange/60 leading-none -mt-3 md:-mt-4 animate-pulse" data-id="element-276" data-mp="28zdiostmbit3">
              :
            </div>
            <div className="flex flex-col items-center min-w-[58px] md:min-w-[78px]" data-id="element-277" data-mp="1zyp3hushncem">
              <div className="text-3xl md:text-5xl font-black text-brandOrange leading-none tabular-nums animate-pulse" data-id="element-278" data-mp="23zhb6jlpp98s">
                {seconds.toString().padStart(2, '0')}
              </div>
              <div className="text-[9px] md:text-[10px] text-gray-400 mt-1.5 md:mt-2 uppercase font-bold tracking-[0.2em]" data-id="element-279" data-mp="1uyswdmohv4uu">
                seg
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-4 md:space-y-5 mb-8 md:mb-10" data-id="element-280" data-mp="1l8q45op75uxk">
          {/* Option Plus - MÁS ELEGIDO */}
          <button type="button" onClick={() => setSelected('plus')} className={`w-full text-left rounded-3xl p-5 md:p-7 relative transition-all duration-300 border-2 ${selected === 'plus' ? 'bg-[#0a1320] border-brandOrange' : 'bg-[#0a1320]/40 border-white/10 hover:border-white/25 opacity-70 hover:opacity-90'}`} data-id="element-281" data-mp="1798aow0yhthv">
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-brandOrange text-white px-4 py-1 rounded-full text-xs font-bold whitespace-nowrap" data-id="element-282" data-mp="zb50stuwxv7w">
              ⭐ MÁS ELEGIDO
            </div>
            <div className="flex items-start gap-3 md:gap-4" data-id="element-283" data-mp="lhdxi37rz7km">
              <div className={`w-6 h-6 rounded-full border-2 mt-1 shrink-0 flex items-center justify-center ${selected === 'plus' ? 'border-brandOrange' : 'border-gray-500'}`} data-id="element-284" data-mp="lip40aslutff">
                {selected === 'plus' && <div className="w-3 h-3 rounded-full bg-brandOrange" data-id="element-285" data-mp="7i4iv7z7wlir"></div>}
              </div>
              <div className="flex-grow min-w-0" data-id="element-286" data-mp="25w7lq8nz6e1a">
                <h4 className="text-lg md:text-2xl font-bold text-white mb-1 leading-tight" data-id="element-287" data-mp="25uwjwee3bgct">
                  🏆 ARSENAL + POTENCIADOR
                </h4>
                <p className="text-brandOrange text-xs md:text-sm font-medium" data-id="element-288" data-mp="3jshba9yvpawe">
                  6 Tomos + 6 Bonos + 6 Volúmenes Potenciador
                </p>
              </div>
              <div className="text-right shrink-0" data-id="element-289" data-mp="3titsbs7hilxs">
                <p className="text-gray-500 line-through text-xs md:text-sm" data-id="element-290" data-mp="3tl6j8uv806mz">
                  $49.990
                </p>
                <p className={`text-2xl md:text-3xl font-black ${selected === 'plus' ? 'text-brandOrange' : 'text-white'}`} data-id="element-291" data-mp="30uo774ciquxf">
                  $21.990
                </p>
              </div>
            </div>
          </button>

          {/* Option Basic */}
          <button type="button" onClick={() => setSelected('basic')} className={`w-full text-left rounded-3xl p-5 md:p-7 transition-all duration-300 border-2 ${selected === 'basic' ? 'bg-[#0a1320] border-brandOrange' : 'bg-[#0a1320]/40 border-white/10 hover:border-white/25 opacity-70 hover:opacity-90'}`} data-id="element-292" data-mp="3eu6303o8f8ga">
            <div className="flex items-start gap-3 md:gap-4" data-id="element-293" data-mp="2q5idvp04ild2">
              <div className={`w-6 h-6 rounded-full border-2 mt-1 shrink-0 flex items-center justify-center ${selected === 'basic' ? 'border-brandOrange' : 'border-gray-500'}`} data-id="element-294" data-mp="2m619kywfnu9h">
                {selected === 'basic' && <div className="w-3 h-3 rounded-full bg-brandOrange" data-id="element-295" data-mp="2v43g1tyxrf45"></div>}
              </div>
              <div className="flex-grow min-w-0" data-id="element-296" data-mp="27e92tbapfojd">
                <h4 className="text-lg md:text-2xl font-bold text-white mb-1 leading-tight" data-id="element-297" data-mp="22ik0j07avtjd">
                  📘 EL ARSENAL DEL PROFE
                </h4>
                <p className="text-gray-400 text-xs md:text-sm" data-id="element-298" data-mp="2cforddc3cd6i">
                  6 Tomos + 6 Bonos · Primaria + Secundaria
                </p>
              </div>
              <div className="text-right shrink-0" data-id="element-299" data-mp="1ooj78lz4ayqe">
                <p className="text-gray-500 line-through text-xs md:text-sm" data-id="element-300" data-mp="1jrj3witnka2z">
                  $34.990
                </p>
                <p className={`text-2xl md:text-3xl font-black ${selected === 'basic' ? 'text-brandOrange' : 'text-white'}`} data-id="element-301" data-mp="3vdbgfo575l0i">
                  $16.990
                </p>
              </div>
            </div>
          </button>

          <CTAButton href={current.checkoutUrl} fullWidth onClick={selected === 'basic' ? markBasicCheckoutReturn : undefined} className="text-sm md:text-xl py-3 md:py-5 mt-2 md:mt-4 animate-glow-button" trackEvent={{
          name: 'InitiateCheckout',
          params: {
            value: current.value,
            currency: 'ARS',
            content_name: current.contentName,
            content_ids: [current.contentId],
            content_type: 'product',
            num_items: 1
          }
        }} data-id="element-302" data-mp="3qf0a3ne41sn1">
            {current.cta} →
          </CTAButton>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 font-medium" data-id="element-303" data-mp="3pe77yhiibp22">
          <span className="flex items-center gap-2" data-id="element-304" data-mp="3lcllq5k31yf7">
            <Lock size={18} data-id="element-305" data-mp="3lbsktl7t234z" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-306" data-mp="3gcz83v0ceg5v">
            <Clock size={18} data-id="element-307" data-mp="3gdr59a9l8ly9" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-308" data-mp="3bffumxbgy7ez">
            <ShieldCheck size={18} data-id="element-309" data-mp="cwshoq6xuff1" /> Garantía 30 días
          </span>
          <span className="flex items-center gap-2 w-full justify-center mt-2" data-id="element-310" data-mp="cvz7ff8rt7s5">
            <CreditCard size={18} data-id="element-311" data-mp="7z0ev14r98w2" /> Mercado Pago | Tarjeta | Transferencia
          </span>
        </div>
      </FadeIn>
    </Section>;
};
export const Footer = () => {
  return <footer className="bg-[#04080f] text-gray-400 py-12 px-4 border-t border-white/5" data-id="element-312" data-mp="3ue1ygjydecml">
      <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-313" data-mp="vns018jxgqzc">
        <div data-id="element-314" data-mp="vpcvr1hzafys">
          <h2 className="text-2xl font-black text-white mb-1" data-id="element-315" data-mp="qwjq8beor3ln">
            ⚽ EL ARSENAL DEL PROFE™
          </h2>
          <p className="text-sm" data-id="element-316" data-mp="y7y6pnzxevjl">by CenterShop Digital</p>
        </div>

        <p className="text-gray-300 max-w-md mx-auto" data-id="element-317" data-mp="ya2h8osbyssu">
          El sistema de clases listas N°1 para profes de Educación Física en
          Argentina. Porque dar una buena clase no debería costarte todos los
          domingos del año.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-sm pt-4" data-id="element-318" data-mp="1d607xrjhj4xo">
          <a href="mailto:soportecentershop95@gmail.com" className="hover:text-white transition-colors" data-id="element-319" data-mp="1h5sk0e837t7s">
            📧 soportecentershop95@gmail.com
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-320" data-mp="1qxokfvxnbvf6">
            📲 @centershop.digital
          </a>
        </div>

        <div className="pt-8 border-t border-white/10 text-xs space-y-2" data-id="element-321" data-mp="1vxj87qm4k4w0">
          <p data-id="element-322" data-mp="20w4by00l56p7">© 2024 CenterShop Digital. Todos los derechos reservados.</p>
          <p className="space-x-4" data-id="element-323" data-mp="24vd26uwf2mg0">
            <a href="#" className="hover:text-white transition-colors" data-id="element-324" data-mp="24wegd88qbp1y">
              Términos y condiciones
            </a>
            <span data-id="element-325" data-mp="39bbp3jg63035">·</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-326" data-mp="39atlu2v37llq">
              Política de privacidad
            </a>
          </p>
        </div>
      </div>
    </footer>;
};